if (!Promise.allSettled) {
  Promise.allSettled = function <T>(promises: Promise<T>[]) {
    return Promise.all(
      promises.map(p =>
        Promise.resolve(p).then(
          value => ({
            status: 'fulfilled' as const,
            value,
          }),
          reason => ({
            status: 'rejected' as const,
            reason,
          }),
        ),
      ),
    )
  }
}
